<template>
  <div>
    <a-card title="订购表单">
      <a-row gutter="16">
        <a-col :span="24" style="max-width: 260px; margin-bottom: 12px;">
          <a-input v-model="searchForm.search" placeholder="标题/链接标识" allowClear @pressEnter="search" />
        </a-col>
        <a-col :span="24" style="width: 100px; margin-bottom: 12px;">
          <a-button type="primary" icon="search" @click="search">查询</a-button>
        </a-col>
        <div style="margin-bottom: 12px; float: right;">
          <a-button type="primary" icon="plus" @click="openModal({})">新建表单</a-button>
        </div>
      </a-row>
      <a-table size="small" :columns="columns" :dataSource="items" rowKey="id" :loading="loading"
        :pagination="pagination" @change="tableChange">
        <div slot="is_active" slot-scope="value">
          <a-tag :color="value ? 'green' : 'red'">{{ value ? '启用' : '停用' }}</a-tag>
        </div>
        <div slot="link" slot-scope="value, item">
          <a :href="h5Url(item)" target="_blank" style="margin-right:8px">打开公开页</a>
          <a-button type="link" size="small" style="padding:0" @click="openShare(item)">分享</a-button>
        </div>
        <div slot="action" slot-scope="value, item">
          <a-button-group>
            <a-button icon="setting" size="small" @click="$router.push(`/orderForm/forms/${item.id}`)">配置</a-button>
            <a-button icon="edit" size="small" @click="openModal(item)">编辑</a-button>
            <a-popconfirm title="确定删除吗？分类、产品与订单也会受影响" @confirm="destroy(item.id)">
              <a-button type="danger" icon="delete" size="small">删除</a-button>
            </a-popconfirm>
          </a-button-group>
        </div>
      </a-table>
    </a-card>

    <a-modal v-model="visible" :title="form.id ? '编辑表单' : '新建表单'" @ok="save" :confirmLoading="saving" width="640px">
      <a-form-model ref="form" :model="form" :rules="rules" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
        <a-form-model-item label="标题" prop="title">
          <a-input v-model="form.title" placeholder="如：巴菲特化工2026冬储价订购" />
        </a-form-model-item>
        <a-form-model-item label="链接标识" prop="slug">
          <a-input v-model="form.slug" placeholder="如：buffett-2026" :disabled="!!form.id" />
          <div style="color:#999;font-size:12px;line-height:1.4;margin-top:4px;">
            用于 H5 公开页 /f/标识 与小程序报价单；创建后不可改
          </div>
        </a-form-model-item>
        <a-form-model-item label="说明" prop="description">
          <a-textarea v-model="form.description" :rows="3" allowClear />
        </a-form-model-item>
        <a-form-model-item label="页面背景" prop="bg_type">
          <a-radio-group v-model="form.bg_type" button-style="solid" size="small">
            <a-radio-button value="default">默认浅色</a-radio-button>
            <a-radio-button value="gradient">渐变</a-radio-button>
            <a-radio-button value="image">图片</a-radio-button>
          </a-radio-group>

          <div v-if="form.bg_type === 'gradient'" style="margin-top:12px">
            <div class="bg-presets">
              <div
                v-for="p in gradientPresets"
                :key="p.name"
                class="bg-preset"
                :class="{ on: form.bg_color_start === p.start && form.bg_color_end === p.end }"
                :style="{ background: `linear-gradient(180deg, ${p.start}, ${p.end})` }"
                :title="p.name"
                @click="applyPreset(p)"
              ></div>
            </div>
            <div style="margin-top:10px">
              <span style="font-size:12px;color:#666;margin-right:6px">起始色</span>
              <input type="color" v-model="form.bg_color_start" class="color-input" />
              <span style="font-size:12px;color:#666;margin:0 6px 0 16px">结束色</span>
              <input type="color" v-model="form.bg_color_end" class="color-input" />
            </div>
          </div>

          <div v-if="form.bg_type === 'image'" style="margin-top:12px">
            <a-upload :showUploadList="false" :customRequest="uploadBg" accept="image/*">
              <a-button icon="upload" size="small" :loading="uploading">上传背景图</a-button>
            </a-upload>
            <a-input
              v-model="form.bg_image"
              placeholder="或直接填写图片地址"
              allowClear
              style="margin-top:8px"
            />
            <div style="color:#999;font-size:12px;margin-top:4px">
              建议竖版大图（如 1080×1920），图片会铺满并固定在页面背景
            </div>
          </div>

          <div v-if="form.bg_type !== 'default'" style="margin-top:12px">
            <a-switch v-model="form.bg_dark" size="small" />
            <span style="font-size:12px;color:#666;margin-left:8px">深色背景（标题、分类名转为白色）</span>
          </div>

          <div v-if="form.bg_type !== 'default'" class="bg-preview" :style="previewStyle">
            <div class="bg-preview__title" :style="{ color: form.bg_dark ? '#fff' : '#101828' }">
              {{ form.title || '报价单标题' }}
            </div>
            <div class="bg-preview__card">产品卡片保持白色，保证可读性</div>
          </div>
        </a-form-model-item>
        <a-form-model-item label="产品图片" prop="show_product_image">
          <a-switch v-model="form.show_product_image" />
          <span style="font-size:12px;color:#666;margin-left:8px">
            开启后顾客端显示产品图片（未传图的产品不占位）
          </span>
        </a-form-model-item>
        <a-form-model-item label="默认字号" prop="font_size">
          <a-radio-group v-model="form.font_size" button-style="solid">
            <a-radio-button value="standard">标准</a-radio-button>
            <a-radio-button value="medium">大</a-radio-button>
            <a-radio-button value="large">超大</a-radio-button>
          </a-radio-group>
          <div style="font-size:12px;color:#666;margin-top:6px">
            顾客打开时的初始字号，顾客也可在页面上自己切换
          </div>
        </a-form-model-item>
        <a-form-model-item label="排序" prop="sort">
          <a-input-number v-model="form.sort" :min="0" style="width:100%" />
        </a-form-model-item>
        <a-form-model-item label="启用" prop="is_active">
          <a-switch v-model="form.is_active" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <a-modal v-model="shareVisible" title="分享报价单（H5 + 小程序）" :footer="null" width="520px" @cancel="shareVisible=false">
      <a-spin :spinning="shareLoading">
        <div v-if="share">
          <div style="margin-bottom:12px"><b>{{ share.title }}</b></div>

          <div style="font-size:12px;color:#666;margin-bottom:8px">H5 公开填单页</div>
          <a-input readOnly :value="shareH5Url" style="margin-bottom:8px">
            <a-button slot="addonAfter" @click="copyText(shareH5Url)">复制</a-button>
          </a-input>
          <a :href="shareH5Url" target="_blank" style="font-size:12px">打开公开页</a>

          <a-divider style="margin:16px 0" />

          <div style="font-size:12px;color:#666;margin-bottom:8px">小程序路径</div>
          <a-input readOnly :value="share.path" style="margin-bottom:8px">
            <a-button slot="addonAfter" @click="copyText(share.path)">复制路径</a-button>
          </a-input>
          <div style="font-size:12px;color:#666;margin:12px 0 8px">小程序 URL Link（微信内打开）</div>
          <a-input readOnly :value="share.url_link || '生成失败，请检查小程序是否已发布并配置'" style="margin-bottom:8px">
            <a-button slot="addonAfter" :disabled="!share.url_link" @click="copyText(share.url_link)">复制链接</a-button>
          </a-input>
          <div v-if="share.url_link_error" style="color:#c0392b;font-size:12px;margin-bottom:8px">
            {{ share.url_link_error }}
          </div>
          <div style="text-align:center;margin-top:16px">
            <div style="font-size:12px;color:#666;margin-bottom:8px">微信扫码进入小程序</div>
            <img v-if="share.qrcode" :src="share.qrcode" alt="小程序码" style="width:220px;height:220px" />
            <div v-else style="color:#999;padding:40px 0">
              {{ share.qrcode_error || '小程序码暂不可用（需小程序已发布）' }}
            </div>
          </div>
          <div style="margin-top:12px;color:#999;font-size:12px;line-height:1.5">
            {{ share.tip }}
          </div>
        </div>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import {
  orderFormList, orderFormCreate, orderFormUpdate, orderFormDestroy, orderFormMpShare,
  orderFormUpload,
} from '@/api/orderForm'

const GRADIENT_PRESETS = [
  { name: '默认浅灰', start: '#f6f7f9', end: '#eef0f4', dark: false },
  { name: '清新绿', start: '#e7f7f0', end: '#f6f7f9', dark: false },
  { name: '晨雾蓝', start: '#e8f1fd', end: '#f7f8fa', dark: false },
  { name: '麦田金', start: '#fdf2e2', end: '#f8f7f4', dark: false },
  { name: '暮霞粉', start: '#fdeceb', end: '#f7f8fa', dark: false },
  { name: '墨绿', start: '#0b3b2c', end: '#0d9f6e', dark: true },
  { name: '深空', start: '#101828', end: '#334155', dark: true },
]

export default {
  name: 'OrderFormList',
  data() {
    return {
      columns: [
        { title: '序号', dataIndex: 'index', customRender: (v, r, i) => i + 1, width: 50 },
        { title: '标题', dataIndex: 'title' },
        { title: '客户入口', dataIndex: 'public_path', scopedSlots: { customRender: 'link' }, width: 200 },
        { title: '分类', dataIndex: 'category_count', width: 70 },
        { title: '产品', dataIndex: 'product_count', width: 70 },
        { title: '订单', dataIndex: 'submission_count', width: 70 },
        { title: '状态', dataIndex: 'is_active', scopedSlots: { customRender: 'is_active' }, width: 70 },
        { title: '操作', dataIndex: 'action', scopedSlots: { customRender: 'action' }, width: 240 },
      ],
      searchForm: { search: '', page: 1, page_size: 16 },
      pagination: { current: 1, total: 0, pageSize: 16 },
      loading: false,
      items: [],
      visible: false,
      saving: false,
      form: {},
      rules: {
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        slug: [{ required: true, message: '请输入链接标识', trigger: 'blur' }],
      },
      shareVisible: false,
      shareLoading: false,
      share: null,
      gradientPresets: GRADIENT_PRESETS,
      uploading: false,
    }
  },
  computed: {
    previewStyle() {
      if (this.form.bg_type === 'image' && this.form.bg_image) {
        return { backgroundImage: `url(${this.form.bg_image})`, backgroundSize: 'cover', backgroundPosition: 'center' }
      }
      if (this.form.bg_type === 'gradient') {
        const start = this.form.bg_color_start || '#f6f7f9'
        const end = this.form.bg_color_end || '#eef0f4'
        return { background: `linear-gradient(180deg, ${start}, ${end})` }
      }
      return { background: '#f6f7f9' }
    },
    shareH5Url() {
      if (!this.share) return ''
      if (this.share.h5_url) return this.share.h5_url
      const path = this.share.h5_path || (this.share.slug ? `/f/${this.share.slug}` : '')
      return path ? `${window.location.origin}${path}` : ''
    },
  },
  methods: {
    h5Url(item) {
      const path = (item && item.public_path) || (item && item.slug ? `/f/${item.slug}` : '')
      return path ? `${window.location.origin}${path}` : '#'
    },
    openShare(item) {
      this.shareVisible = true
      this.share = null
      this.shareLoading = true
      orderFormMpShare(item.id)
        .then((data) => { this.share = data || {} })
        .catch(() => this.$message.error('获取分享信息失败'))
        .finally(() => { this.shareLoading = false })
    },
    copyText(text) {
      if (!text) return
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(() => this.$message.success('已复制'))
      } else {
        this.$message.info(text)
      }
    },
    list() {
      this.loading = true
      orderFormList(this.searchForm).then((data) => {
        this.pagination.total = data.count
        this.items = data.results
      }).finally(() => { this.loading = false })
    },
    search() {
      this.searchForm.page = 1
      this.pagination.current = 1
      this.list()
    },
    tableChange(pagination) {
      this.pagination = pagination
      this.searchForm.page = pagination.current
      this.searchForm.page_size = pagination.pageSize
      this.list()
    },
    openModal(item) {
      const data = { is_active: true, sort: 0, ...item }
      // 老数据这些字段为 null，色板控件需要合法的 #rrggbb
      this.form = {
        ...data,
        bg_type: data.bg_type || 'default',
        bg_color_start: data.bg_color_start || '#e7f7f0',
        bg_color_end: data.bg_color_end || '#f6f7f9',
        bg_image: data.bg_image || '',
        bg_dark: !!data.bg_dark,
        show_product_image: !!data.show_product_image,
        font_size: data.font_size || 'standard',
      }
      this.visible = true
    },
    applyPreset(preset) {
      this.$set(this.form, 'bg_color_start', preset.start)
      this.$set(this.form, 'bg_color_end', preset.end)
      this.$set(this.form, 'bg_dark', preset.dark)
    },
    uploadBg({ file }) {
      this.uploading = true
      orderFormUpload(file)
        .then((data) => {
          this.$set(this.form, 'bg_image', (data && data.url) || '')
          this.$message.success('上传成功')
        })
        .catch(() => this.$message.error('上传失败'))
        .finally(() => { this.uploading = false })
    },
    save() {
      this.$refs.form.validate((ok) => {
        if (!ok) return
        this.saving = true
        const api = this.form.id ? orderFormUpdate : orderFormCreate
        api(this.form).then(() => {
          this.$message.success('保存成功')
          this.visible = false
          this.list()
        }).finally(() => { this.saving = false })
      })
    },
    destroy(id) {
      orderFormDestroy({ id }).then(() => {
        this.$message.success('删除成功')
        this.list()
      })
    },
  },
  mounted() {
    this.list()
  },
}
</script>

<style scoped>
.bg-presets {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.bg-preset {
  width: 44px;
  height: 30px;
  border-radius: 6px;
  border: 2px solid transparent;
  box-shadow: inset 0 0 0 1px rgba(16, 24, 40, 0.08);
  cursor: pointer;
}
.bg-preset.on {
  border-color: #0d9f6e;
}
.color-input {
  width: 44px;
  height: 28px;
  padding: 0;
  border: 1px solid #eaecf0;
  border-radius: 6px;
  background: #fff;
  vertical-align: middle;
  cursor: pointer;
}
.bg-preview {
  margin-top: 12px;
  border-radius: 10px;
  padding: 16px;
  border: 1px solid #eaecf0;
}
.bg-preview__title {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 10px;
}
.bg-preview__card {
  background: #fff;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 12px;
  color: #475467;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.06);
}
</style>
